import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import VehicleTypePane from 'src/components/global-settings/VehicleTypePane'
import { createVehicleType, getVehicleCreateOptions } from 'src/state/actions/vehicles'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    carTypes: state.vehicleCreateOptions.carTypes
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    createVehicleType: (name: string) => dispatch(createVehicleType(name)),
    getVehicleCreateOptions: () => dispatch(getVehicleCreateOptions())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(VehicleTypePane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/VehicleTypePane.ts